module.exports = __webpack_public_path__ + "static/img/8.5a2e098.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/8.png
// module id = gSH3
// module chunks = 0